// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";

function NicknamePaymentInput(props) {
  var match = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.userCardNickName);
  var setNickName = match[1];
  var match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var onChange = function (ev) {
    var val = ev.target.value;
    setNickName(function (prev) {
          return Utils$OrcaPaymentPage.setNickNameState(val, prev, localeString);
        });
  };
  var onBlur = function (ev) {
    var val = ev.target.value;
    setNickName(function (prev) {
          return Utils$OrcaPaymentPage.setNickNameState(val, prev, localeString);
        });
  };
  return React.createElement(PaymentField$OrcaPaymentPage.make, {
              setValue: setNickName,
              value: match[0],
              onChange: onChange,
              onBlur: onBlur,
              fieldName: localeString.cardNickname,
              name: "userCardNickName",
              type_: "userCardNickName",
              maxLength: 12,
              placeholder: localeString.nicknamePlaceholder,
              inputRef: React.useRef(null)
            });
}

var make = NicknamePaymentInput;

export {
  make ,
}
/* jotai Not a pure module */
